import { render } from "./reportReservation.vue?vue&type=template&id=7080221d"
import script from "./reportReservation.vue?vue&type=script&lang=js"
export * from "./reportReservation.vue?vue&type=script&lang=js"

import "./reportReservation.vue?vue&type=style&index=0&id=7080221d&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__